var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import LoginLayout from "./layout/loginLayout";
import AllowAnonymousLayoutLayout from "./layout/allowAnonymousLayoutLayout";
import MainLayout from "./layout/mainLayout";
import { CallApp, AppPromotion, AppointmentDetails, ErrorPage } from './scenes';
import NewMainLayout from "./layout/newMainLayout";
import { NotificationManager } from "oned";
var NoMatch = function () {
    // no match go home.
    return React.createElement("div", null, "not found");
};
var exteriorAllowAnonymousMenus = [
    { path: '/callApp', component: CallApp, title: 'CallApp' },
    { path: '/AppPromotion', component: AppPromotion, title: 'AppPromotion' },
    { path: '/appointmentDetails', component: AppointmentDetails, title: 'AppointmentDetails' },
    { path: '/error/:code', component: ErrorPage, title: 'Error' },
];
var Router = function () {
    return (React.createElement(React.Suspense, { fallback: null },
        React.createElement(HashRouter, null,
            React.createElement(NotificationManager, null),
            React.createElement(Switch, null,
                exteriorAllowAnonymousMenus.map(function (x) {
                    return React.createElement(Route, { key: x.path, exact: true, path: x.path, component: x.component, title: x.title });
                }),
                React.createElement(Route, { path: "/emailToSchedule/(tokenExpired|unableSchedule)", render: function (props) { return React.createElement(AllowAnonymousLayoutLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/ResidentScheduleOptimization/EmailToSchedule/(tokenExpired|unableSchedule|noTechnician|timeApproaching)", render: function (props) { return React.createElement(AllowAnonymousLayoutLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/ResidentScheduleOptimization/(EmailToSchedule|EmailToSchedule/success)", render: function (props) { return React.createElement(MainLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/account", render: function (props) { return React.createElement(LoginLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/newRequest", render: function (props) { return React.createElement(NewMainLayout, __assign({}, props, { needCopilotFixedButton: true })); } }),
                React.createElement(Route, { path: "/", render: function (props) { return React.createElement(MainLayout, __assign({}, props, { needCopilotFixedButton: true })); } }),
                React.createElement(Route, { component: NoMatch })))));
};
export default Router;
